export const FEATURE_LABELS = {
  document_manager: "Document manager",
  documents: "Documents",
};

export default FEATURE_LABELS;
